import { render, staticRenderFns } from "./renYuanXinXi.vue?vue&type=template&id=6d28a4b9&scoped=true&"
import script from "./renYuanXinXi.vue?vue&type=script&lang=js&"
export * from "./renYuanXinXi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d28a4b9",
  null
  
)

export default component.exports